import { Injectable } from '@angular/core';

export const PASSWORD_MIN_LENGTH: number = 6;
export const TIME_TO_ACTIVATE_RESEND_SMS: number = 60;
export const TOAST_DURATION: number = 3000;
export const COUNTRY_SETTINGS_ENABLE_VALUE: number = 1;
export const SEND_REGARDLESS_ONHOLD = true;
export const NOT_SEND_REGARDLESS_ONHOLD = false;
export const MOBILE_WALLET_FIELDID = 46202;
export const TRANSFER_REASON_FIELDID = 11401;
export const RELATIONSHIP_FIELDID = 40401;
export const PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
  PHONE: `^[0-9\\.\\-\\+\\(\\)\\[\\] ]{3,18}$`,
  MOBILE_WALLET: '^[1-9]+[0-9]*',
  REGISTRATION_EMAIL: `^([\\s]*)([\\w-\\.+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)([\\s]*)$`,
  PASSWORD: `^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$`,
  REGISTRATION_CRITERIA_LETTER: /^(?=.*[A-Z]).{1,}$/,
  REGISTRATION_CRITERIA_LOWER_CASE: /^(?=.*[a-z]).{1,}$/,
  REGISTRATION_CRITERIA_NUMBER: /^(?=.*[0-9]).{1,}$/,
};
export const ONFIDO_MAXIMUM_ATTEMPTS_RET_VAL = 2;
export const DRIVER_LICENSE_FIELD_ID = '14601';
export const DRIVER_LICENSE_FIELD_VALUE = '10112';
export const ISSUED_COUNTRY_FIELD_ID = '19001';
export const FRAUD_PHONE_NUMBER = '(877) 443-1399';

export const PAGES = {
  HOME: 'RedesignHomePage',
  MY_BENEFICIARIES: 'RedesignMyBeneficiariesPage',
  MY_PROFILE: 'MyProfilePage',
  MY_TRANSACTIONS: 'RedesignMyTransactionsPage',
  NEW_ORDER_AMOUNTS: 'RedesingNewOrderAmountsPage',
  NEW_ORDER_CONFIRM: 'RedesignNewOrderConfirmPage',
  NEW_ORDER_BANK_REQUIRED_DATA: 'RedesignNewOrderBankRequiredDataPage',
  NEW_ORDER_REQUIRED_DATA: 'RedesignNewOrderRequiredDataPage',
  NEW_ORDER_MANAGE_BENEFICIARY: 'RedesignNewOrderRequiredDataPage',
  NEW_ORDER_SELECT_BENEFICIARY: 'RedesignNewOrderSelectBeneficiaryPage',
  NEW_ORDER_SELECT_BENEFICIARY_DETAILS: 'RedesignNewOrderSelectBeneficiaryDetailsPage',
  NEW_ORDER_SELECT_COUNTRY: 'RedesignNewOrderSelectCountryPage',
  NEW_ORDER_SELECT_DELIVERY_METHOD: 'RedesingNewOrderSelectDeliveryMethodPage',  
  NEW_ORDER_SELECT_CITY: 'RedesingNewOrderSelectCityPage',
  NEW_ORDER_SELECT_LOCATION: 'RedesignNewOrderSelectLocationPage',
  NEW_ORDER_SELECT_TYPE: 'RedesignNewOrderSelectTypePage',
  NEW_TRANSACTION: 'RedesignNewTransactionPage',
  NEW_TRANSACTION_PREVIEW: 'RedesignNewTransactionPreviewPage',
  NEW_TRANSACTION_RESULT_ERROR: 'NewTransactionErrorPage',
  NEW_TRANSACTION_RESULT_SUCCESS: 'NewTransactionSuccessPage',
  SENDING_CERTIFICATE: 'SendingCertificatePage',
  SETTINGS: 'RedesignSettingsPage',
  SIGN_IN: 'SignInPage',
  TERMS_AND_CONDITIONS: 'TermsAndConditionsPage',
  TRACK_TRANSACTION: 'RedesignTrackTransactionPage',
  TRANSACTION_DETAILS: 'RedesignTransactionDetailsPage',
  TRANSACTION_PAY: 'RedesignTransactionPayPage',
  TRANSACTION_FINISH_DIGITAL: 'SendCompletedPage',
  TOKBOX: 'TokBoxPage',
  APP_STATUS: 'RedesignAppStatusPage',
  CONTACT: 'SelectContactPage',
  CONTACT_EMAIL: 'RedesignContactPage',
  CURRENCY_EXCHANGE: {
    TRANSACTION: 'RedesignCurrencyExchangePage',
    RESERVATION: 'RedesignCurrencyExchangeReservationPage',
    RESERVATION_INFO: 'RedesignCurrencyExchangeReservationInfoPage'
  },
  FIND_LOCATION: 'RedesignFindLocationPage',
  INFO: 'RedesignInfoPage',
  RESULT_INFO: 'ResultInfoPage',
  NEW_INFO: 'RedesignNewInfoPage',
  LINK_CUSTOMER: 'LinkCustomerPage',
  LINK_CUSTOMER_FORM: 'RedesignLinkCustomerFormPage',
  CUSTOMER_LINKING: {
    SMS_SCREEN: 'RedesignLinkCustomerAccountVerificationPage',
    SET_PASSWORD: 'RedesignLinkCustomerSetPasswordPage'
  },
  FORGOT_PASSWORD: 'RedesignForgotPasswordPage',
  LINK_CUSTOMER_SMS: 'RedesignLinkCustomerAccountVerificationPage',
  LINK_CUSTOMER_VIDEO: 'RedesignLinkCustomerVideoPage',
  LINK_CUSTOMER_OCR: {
    FORM: 'RedesignLinkCustomerOcrFormPage',
    SELECT_DOCUMENT: 'RedesignLinkCustomerSelectDocumentPage',
    INFO: 'RedesignLinkCustomerOcrInfoPage',
    INFO_HELP: 'LinkCustomerOrcInfoHelpPage',
    UPLOAD_IMAGES: 'RedesignLinkCustomerUploadOcrImgsPage',
    UPLOAD_IMAGES_HELP: 'LinkCustomerUploadOcrImgsHelpPage',
    LOADING: 'RedesignLinkCustomerLoadingPage',
    NEW_CUSTOMER_LOADING: 'RedesignLinkCustomerNewCustomerLoadingPage',
    ONFIDO_SELECT_DOCUMENT: 'LinkCustomerOnfidoSelectDocumentPage',
    ONFIDO_LOADING: 'LinkCustomerOnfidoLoadingPage',
  },
  LOGIN: 'RedesignLoginPage',
  OTP_SCREEN: 'OtpScreenPage',
  CHANGE_PASSWORD: 'RedesignChangePasswordPage',
  CODE_PASSWORD: 'RedesignCodePasswordPage',
  MY_BENEFICIARIES_ADDRESS: 'RedesignMyBeneficiariesAddressPage',
  MY_BENEFICIARIES_BANK:'RedesignMyBeneficiariesBankPage',
  MY_BENEFICIARIES_BANK_DETAILS:'RedesignMyBeneficiariesBankDetailsPage',
  MODAL_FILTER_TRANSACTIONS: 'RedesignModalFilterTransactionsPage',
  MOBILEVERIFY: 'MobileVerifyPage',
};
export const VISIBILITY_ICON = {
  OFF: 'assets/img/login-register/visibility-off.svg',
  ON: 'assets/img/login-register/visibility.svg'
};

export const ANALYTICS_PAGES = {
  HOME: 'Home',
  MY_BENEFICIARIES: 'Send money (Select a beneficiary)',
  MY_PROFILE: 'My profile',
  MY_TRANSACTIONS: 'My transactions',
  NEW_ORDER_AMOUNTS: 'New Order (Fill amounts)',
  NEW_ORDER_CONFIRM: 'New Order (Confirm order)',
  NEW_ORDER_MANAGE_BENEFICIARY: 'New Order (Manage beneficiary)',
  NEW_ORDER_SELECT_BENEFICIARY: 'New Order (Select beneficiary)',
  NEW_ORDER_SELECT_BENEFICIARY_DETAILS: 'New Order (Select beneficiary details redesign)',
  NEW_ORDER_SELECT_CITY: 'New Order (Select city)',
  NEW_ORDER_SELECT_COUNTRY: 'New Order (Select country)',
  NEW_ORDER_SELECT_DELIVERY_METHOD: 'New Order (Select delivery method)',
  NEW_ORDER_SELECT_LOCATION: 'New Order (Select location)',
  NEW_ORDER_SELECT_ORDER_REASON: 'New Order (Select reason)',
  NEW_ORDER_SELECT_TYPE: 'New Order (Select type)',
  NEW_TRANSACTION: 'Send money (Fill transaction form)',
  NEW_TRANSACTION_PREVIEW: 'Send money (Confirm transaction)',
  NEW_TRANSACTION_RESULT_ERROR: 'Send money (Transaction Summary)',
  NEW_TRANSACTION_RESULT_SUCCESS: 'Send money (Transaction Summary)',
  SENDING_CERTIFICATE: 'Sending certificate',
  SETTINGS: 'Settings',
  SIGN_IN: 'Sign in',
  TERMS_AND_CONDITIONS: 'Terms and conditions',
  TRACK_TRANSACTION: 'Track an order',
  TRANSACTION_DETAILS: 'Transaction details',
  TRANSACTION_PAY: 'Show in store',
  TOKBOX: 'Link customer (Tok box)',
  UPDATE: 'Deprecated App Version',
  OFFLINE: 'Offline status',
  CHANGE_PASSWORD: 'Change password',
  CODE_PASSWORD: 'New password (code page)',
  CONTACT: 'Contact',
  CURRENCY_EXCHANGE: {
    TRANSACTION: 'Currency Exchange Transaction',
    RESERVATION: 'Currency Exchange Reservation',
    RESERVATION_INFO: 'Currency Exchange Transaction Information'
  },
  FIND_LOCATION: 'Find location',
  FORGOT_PASSWORD: 'New password',
  INFO: 'Info',
  NEW_INFO: 'New info page',
  LINK_CUSTOMER: {
    LINK: '',
    FORM: 'Link customer (Form)',
    IDNOW: 'Link customer (Idnow)',
    TOKBOX: 'Link customer (TOKBOX)',
    MITEK: 'Link customer (MITEK)',
    CUSTOMER_LINKING: 'Link Customer (Customer Linking)',
    ONFIDO: 'Link customer (ONFIDO)'
  },
  LINK_CUSTOMER_OCR: {
    FORM: 'LinkCustomerOcrFormPage'
  },
  LOGIN:  'Login',
  OTP_SCREEN: 'OTP Input screen'
};

export const DATE_FORMAT_EN = 'MM/DD/YYYY';
export const DATE_FORMAT = 'DD/MM/YYYY';

export const TRANSACTION_RETVAL = {
  SUCCESS: 1,
  PRICING_ERRORS: 20,
  INVALID_REQUEST_MIN_AMOUNT: 500,
  INVALID_REQUEST_MAX_AMOUNT: 510
};

export const ADD_PROMOTIONS_RETVAL = {
  SUCCESS: 1,
  INVALID_REFERRAL_CODE: 10,
  INVALID_EXPIRATION_DATE: 20,
  REFERRAL_CODE_ALREADY_USED: 30
};

export enum DOCUMENT_TYPES {
  OTHER = 0,
  DRIVER_LICENSE = 301,
  PASSPORT = 401,
  NATIONAL_ID_CARD = 601,
  RESIDENCE_PERMIT_CARD = 1301
}

export enum FEATURES {
  LINK_TO_CUSTOMER = 1,
  STAGED_TRANSACTION = 2,
  NEW_ORDER = 3,
  REFER_A_FRIEND = 4
}

export enum KYC_PROVIDERS {
  IDNOW = 10,
  TOKBOX = 20
}

export enum KYC_STATUS {
  KYC_SUCCESS = 10,
  KYC_IN_PROGRESS = 20,
  KYC_ERROR = 30,
  KYC_CONSIDER = 'consider',
  KYC_SUSPECTED = 'suspected'
}

export enum KYC_ATTEMPT_STATUS {
  NOT_ATTEMPTED = 0,
  VERIFIED = 1,
  FAIL = 2,
  IN_PROGRESS = 3,
  UPDATE_CURRENT_ID = 4
}

export enum KYC_ERROR_STATUS {
  NONE = 0,
  DOCUMENT_NOT_READABLE = 10,
  DOCUMENT_EXPIRED = 50,
  DOCUMENT_IS_NOT_SUPPORTED = 60,
  OTHER = -10
}

export const KYC_METHODS = {
  OCR: 'OCR+NewCustomer',
  UNAVAILABLE: 'NoKYC',
  VALIDATING: 'ValidatingKYC',
  ONFIDO: 'Onfido',
  VERIFF: 'Veriff',
  SIGNICAT: 'Signicat',
  SINGPASS: 'Singpass',
  DIGITAL_ID_VERIFICATION: 'DigitalIDVerification'
};

export enum PENDING_ORDER {
  YES = 1,
  NO = 10
}
export enum ALERT_TYPE {
  ALERT_INFO = "info",
  ALERT_WARNING = "warn",
  ALERT_ERROR = "error",
  ALERT_SUCCESS = "success",
  PREPAID_CARD = "prepaidCard",
  ALERT_SHIELD = "shield",
  ALERT_PENDING = "pending",
  ALERT_IMPORTANT = "important"
}
export enum COUNTRY_SETTINGS {
  CUSTOMERS_SERVICE_NUMBER = 27400,
  CUSTOMER_SERVICE_EMAIL = 27300,
  SIGNIN_IS_SHOWN_IN_MAIN_MENU = 26400,
  SENDMONEY_IS_SHOWN_IN_MAIN_MENU = 26500,
  SENDMONEY_HOME_ORDER_VIEW = 26550,
  MYTRANSACTIONS_IS_SHOWN_IN_MAIN_MENU = 26600,
  MYTRANSACTIONS_HOME_ORDER_VIEW = 26650,
  SENDINGCERTIFICATE_IS_SHOWN_IN_MAIN_MENU = 26700,
  MAPS_IS_SHOWN_IN_MAIN_MENU = 26800,
  MAPS_HOME_ORDER_VIEW = 26850,
  TRACKANDORDER_IS_SHOWN_IN_MAIN_MENU = 26900,
  TRACKANDORDER_HOME_ORDER_VIEW = 26950,
  SETTINGS_IS_SHOWN_IN_MAIN_MENU = 27000,
  CONTACTUS_IS_SHOWN_IN_MAIN_MENU = 27100,
  ABOUT_LINK = 27500,
  TERMS_AND_CONDITIONS_LINK = 27600,
  PRIVACY_POLICY_LINK = 27700,
  KYC = 28000,
  CURRENCY_EXCHANGE_IS_SHOWN_IN_MAIN_MENU = 29600,
  EMAIL_SIGNUP_ACTIVE = 30200,
  EMAIL_SIGNUP_REQUIRED = 30300,
  EMAIL_SIGNUP_ORDER = 30400,
  MOBILE_SIGNUP_ACTIVE = 30500,
  MOBILE_SIGNUP_REQUIRED = 30600,
  MOBILE_SIGNUP_ORDER = 30700,
  CUSTOMER_LINKING_ENABLED = 32300,
  TIME_BETWEEN_TOKENS_TYPE = 32600,
  TIME_BETWEEN_TOKENS = 32700,
  ALLOW_RESEND_SMS = 33100,
  SHOW_ORDERS_IN_SENDING_CURRENCY = 35300,
  CREATE_NEW_TRANSACTION = 36000,
  SHOW_VERACITY_DISCLOSURE = 36200,
  REQUIRE_TERMS_AND_CONDITIONS_ACCEPTANCE = 40400,
  KYC_INCLUDE_FACE_RECOGNITION = 40100,
  ATM_COLLECTOR_ENABLED = 37400,
  AMOUNT_DISPLAYED_IN_TRANSACTION_LITS = 40700,
  FAQ_LINK = 40600,
  OTP_LOGIN = 40800,
  OTP_NEW_ORDER = 40810,
  OTP_REPEAT_ORDER = 40820,
  OTP_CHANGE_PASSWORD = 42800,
  OTP_RECOVERY_PASSWORD = 42700,
  ADD_BENEFICIRY = 42900,
  ENABLE_LOCAL_AMOUNT = 43000,
  ENABLE_TOTAL_AMOUNT = 43010,
  SEND_TRANSACTION_ENABLED = 43100,
  ONFIDO_FACE_VIDEO_ENABLED = 43600,
  ONFIDO_ALLOWED_DOCUMENTS = 43800,
  OTP_MAX_ATTEMTPS = 42500,
  DIGITAL_AGENT = 44100,
  REFER_A_FRIEND = 45000,
  LOQATE_ADDRESS_ENABLE = 46900,
  DIGITAL_COUNTRY_LICENSE = 47000,
  ENABLE_WALLET = 49000,
  LITE_REGISTRATION = 93000,
  PILOT_DEVICES = 93010,
  PILOT_COUNTRY_SETTINGS = 93011,
  DIGITAL_SEND_MONEY_FIELDS_SCREEN_GROUPING_ENABLED = 95005,
  DIGITAL_SEGMENT_RESET_AFTER_LOGOUT = 95505,
  FALLBACK_EKYC_METHOD = 95507,
  DIGITAL_OPTIONAL_SEND_MONEY_FIELDS_ISENABLED = 95004,
  DIGITAL_RESTRICT_SENDTO_COUNTRY = 96601,
  DIGITAL_STAGED_SENDAMOUNTRESTRICTION_MULTIPLESOF = 96901,
  DIGITAL_WELCOME_RATE_AVAILABLE = 97000,
  HIGHER_LIMIT_EKYC_PROCESSOR = 98200,
  SHOW_SOFT_OPTIN = 509,
  ENABLE_RIA_PRE_PAID_CARDS = 49003,
  ENABLE_PHYSICAL_RIA_PRE_PAID_CARD_ISSUANCE = 49004,
  ENABLE_VIRTUAL_RIA_PRE_PAID_CARD_ISSUANCE = 49005,
  HAPPY_REVIEW_SYSTEM_ENABLE = 98500,
  EENABLE_MOBILE_TOP_UP = 49007,
  REFER_A_FRIEND_NEW = 98610,
  PIN_ONLY_REGISTRATION = 93001,
  PIN_LOGIN_ENABLED = 93002,
  ENABLE_EKYC_SINGPASS = 45001,
  IS_UNDERAGE_LIMIT = 45002,
  DIGITAL_REQUIRED_STATE_AND_CITY_IN_BENEFICIENT_FORM = 99030,
  ENABLE_SINGPASS_REG = 45020,
  ENABLE_SANDBOX = 45010,
  SANDBOX_COUNTRY_LIST = 45005,
  CURRENT_SANDBOX_COUNT = 45004,
  MAX_SANDBOX_USE_COUNT = 45003,
  DISABLE_BILL_PAY = 49012,
  DISABLE_INWARD_REMMITANCE = 49013,
  DISABLE_CDM_DEPOSIT = 49014,
  DISABLE_P2P = 49016,
  ENABLE_WALLET_RETAIL_PAYMENT = 49017,
  ENABLE_ADYEN_REGIONAL_ENDPOINTS = 93400,
  ENABLE_NEW_BIOMETRICS_REGISTER = 93005,
  ENABLE_DUITNOW_QR = 49022,
  DIGITAL_SHOW_TRANSACTION_HISTORY_REPORT = 99531
}

export const AGENT_SETTINGS = {
  MAESTRO_ALLOWED: {
    Type: 9200,
    Value: "1"
  } 
}

export enum EVENTS_ID {
  USER_BEGIN_KYC = 7002,
  USER_FINISH_KYC = 7102
}

export enum SESSION_STATE {
  NOT_LOGGED,
  LOGGED,
  CUSTOMER
}

export const USER_FEATURES = {
  LANGUAGE: { AREA: 1, TYPE: 11 },
  PREFERRED_COUNTRY: { AREA: 1, TYPE: 20 },
  RESERVED_CUSTOMER_ID: { AREA: 1, TYPE: 30},
  RAF: {AREA: 1, TYPE: 40},
  ACCOUNT_DELETION: {AREA: 1, TYPE: 90}
};

export const USER_LOGINS = {
  EMAIL: { TYPE: 10 },
  MOBILE: { TYPE: 20}
};

export const CUSTOMER_SETTINGS = {
  CUSTOMER_PREFERRED_COUNTRY: { AREA: 4401, TYPE: 100 },
  RIA_ALERTS_ASK_LATER: { AREA: 4401, TYPE: 210 },
  RIA_ALERTS_SO_NOT_PROMPT: { AREA: 4401, TYPE: 211 },
  MARKETING_MESSAGES: { AREA: 4401, TYPE: 217 },
  SERVICE_MESSAGES: { AREA: 4401, TYPE: 218 },
  ONFIDO_ATTEMPTS: { AREA: 4401, TYPE: 900 },
  LT_LICENSE_TERMS_AND_CONDITIONS: { AREA: 4401, TYPE: 1200},
  RIA_TERMS_CONDITIONS: { AREA: 4401, TYPE: 1201 },
  WMT_TERMS_CONDITIONS: { AREA: 4401, TYPE: 1202 },
  RAF_REFERRAL_CODE: { AREA: 4401, TYPE: 1000 },
  RAF_REFERRAL_URL: { AREA: 4401, TYPE: 85 },
  MFA_PREFERENCE: { AREA: 4401, TYPE: 223 },
  PENDING_ORDER_DETAILS: { AREA: 4401, TYPE: 333 },
  PENDING_ORDER_EXPIRED: { AREA: 4401, TYPE: 335 },
  COMPLETED_DIGITAL_TRANSACTION: { AREA: 4401, TYPE: 1301 },
  CUSTOMER_SETUP_NEW_BIOMETRIC: { AREA: 4415, TYPE: 301 },
  TRANSACTIONAL_NPS_TIMESTAMP: { AREA: 4401, TYPE: 27002 },
};

export const REGISTER_RET_VAL = {
  SIGN_IN: 1,
  REFER_A_FRIEND: 2,
  BLOCKED: 190,
  SIGN_IN_REGISTERED_WITH_TOKEN:0,
  OTP_MAX_ATTEMPTS: 100,
  PASSWORD_DOES_NOT_MATCH: 150,
  PASSWORD_ATTEMPTS_EXCEEDED: 160,
  PESEL_NUMBER_INVALID: 240,
  CUSTOMER_LINKING_KNOWLEDGE_QUESTION: 230,
  CUSTOMER_FOUND_MERGE_SUCCESS: 3,
  CUSTOMER_FOUND_MERGE_FAILED: 4,
  CUSTOMER_PIN_INVALID_CONTAIN: 111
}

export const LITE_REGISTER_RET_VAL = {
  SUCCESS: 1,
  VERIFICATION_ERROR: 50,
  INCORRECT_MOBILE_NUMBER: 20,
  CUSTOMER_RESOURCE_NOT_VERIFIED: 100,
  CUSTOMER_RESOURCE_VERIFICATION_NOT_FOUND_OR_EXPIRED: 105,
  PASSWORD_NOT_VALID: 110,
  ERROR_CREATING_USER: 120,
  ERROR_LINKING: 130,
  INVALID_REFERAL_CODE: 160,
  BLOCKED: 190,
  INVALID_BOX_MAIL_ADDRESS: 210,
  PROFILE_DATA_ERROR: 30,
  ADDRESS_NOT_VERIFIED: 55,
  CITY_NOT_RECOGNIZED: 56,
  ID_DETAILS_ERROR: 58
}

export enum LOGIN_ERRORS_NEW_TOKEN {
  SUCCESS = 1,
  INVALID_GRANT = 10,
  OTP_ERRORS = 60,
  PHONE_NUMBER_TYPE_NOT_SUPPORTED = 63,
  NO_CONTACT_DATA = 70,
  VERIFY_PHONE_NUMBER = 80,
  BLOCKED_USER = 90,
  BLOCKED_PASSWORD_USER = 100,
  BLOCKED_PASSWORD_QUESTIONS = 110,
  NO_DEVICE_INFO = 160,
  MFA_MIGRATION_NOT_VERIFIED = 170,
  BLOCKED_BY_OTP_FAILED_ATTEMPS = 180,
  DUPLICATE_ACCOUNT = 230,
  BLOCKED_CANNOT_SEND = 250,
  OTP_CHANNEL_PICKER = 270,
  PENDING_SIGNIN_INVALID = 330,
  OTP_LOOKUP_FAILED = 340,
  MFA_PREFERENCE_NOT_SUPPORTED = 350,
  INVALID_PASS = 20
}

export enum LoginFailureReason {
  BIOMETRIC_INVALIDATED = 'BIOMETRIC_INVALIDATED',
  MALFORMED_STORED_TOKEN = 'MALFORMED_STORED_TOKEN'
}

// Sentinel resolved by the native biometric verify path (KeyPermanentlyInvalidatedException) and
// checked in AuthProvider.getStoredFingerprintToken. Shared here so both providers can reference it.
export const BIOMETRIC_KEY_INVALIDATED = 'BIOMETRIC_KEY_INVALIDATED';


export const LOGIN_TYPE = {
  EMAIL: 10,
  PHONE: 20
}

export const DELIVERY_TYPE = {
  SMS: 10,
  EMAIL: 20,
  VOICE: 30,
  WHATSAPP: 40
};

export enum RET_VAL {
  HAPPY_PATH = 0,
  REQUIRED_FIELDS_VALID = 1,
  ORDER_RESTRICTIONS_MATCHED = 10, // ejemplo, ya no se utilice esa moneda, location dada de baja
  REQUIRED_FIELDS_MATCHED = 20, // campos no validos de beneficiario, por ejemplo, falta el nombre, profesion de beneficiario, puede ocurrir cuando se han añadido nuevos campos obligatorios desde el ultimo giro
  INVALID_REQUIRED_FIELDS_MATCHED = 25,
  ORDER_AMOUNT_OUT_OF_PAYOUT_AGENT_LIMITS = 30, // corresponsal pagador se ha pasado de los limites que le debe a ria
  POSSIBLE_DUPLICATED_ORDER = 40, // para evitar que se dupliquen ordenes, el usuario ha intentando hacer la misma orden en los ultimos x minutos
  SAR_VALIDATION_ON_HOLD = 50, // actividad sospechosa -> Por ejemplo, se detecta que un benef esta recibiendo dinero d varios paises
  SAR_VALIDATION_REJECTED = 55,
  WRONG_SENT_AMOUNTS = 60, // ha cambiado algun campo, como el cambio
  INVALID_SEND_CURRENCY = 65, // La moneda de envío no esta soportada por el agente
  AGENT_IS_ON_HOLD = 70, // el agente enviador esta deshabilitado
  AR_OVER_DAILY_LIMIT = 80, // si el benef se pasa de dinero recibido al dia
  AR_OVER_BALANCE_LIMIT = 90, // si el benef se pasa de dinero recibido al dia que le debe
  TRANSACTION_OVER_THE_LIMIT = 100, // si el benef se pasa de dinero recibido
  WATCHLIST_MATCHED = 110,
  INVALID_FORGOT_METHOD = 120,
  CUSTOMER_ON_HOLD = 2000,
  EXPIRED_OTP = 4000,
  INVALID_OTP = 4100,
  OTP_REQUIRED = 4200,
  ERROR_CREATING_OTP = 4300,
  NO_CONTACT_DATA = 4400,
  VERIFY_PHONE_NUMBER = 4500,
  REQUIRED_IDENTITY_VERIFICATION = 4700,
  HIGHER_LIMIT_IDENTITY_VERIFICATION = 4701,
  REQUIRED_PIN_CODE = 5800,
  PIN_CODE_WALLET_MAX_ATTEMPTS = 6000,
  REQUEST_OTP = 307,
  WALLET_TXN_AMOUNT_LIMIT_REACHED = 6600, // TRANSACTION AMOUNT LIMIT REACHED ( example, max widraw is 1000 if it reached or exceeds the limit)
  WALLET_TXN_LIMIT_EXCEEDED = 6700, // EXCEEDING TRANSACTION LIMIT - Please Ignore this. not applicable
  WALLET_TXN_COUNT_LIMIT_REACHED = 6800, // TRANSACTION COUNT LIMIT REACHED - ( example, we only allow 3 txn per txn type per day)
  WALLET_TXN_EXCEEDS_FUNDS_AVAILABLE = 6900, // EXCEEDS FUNDS AVAILABLE - when txn amount > Balance
  FRAUD_VERIFICATION_FAILED_CUSTOMER = 7000, // Accertify failure message to the Customer || Fraud verification Failed, Hard Reject
  FRAUD_CHECK_FAILURE_EXCEPTION = 8115, // Soft Reject
  MISSING_BANK_DETAILS = 7003,
  MISSING_PAYMENT_METHOD = 7004,
  SN_PIN_MAX_ATTEMPTS = 100, // When SN exceeds MAX PIN ATTEMPTS // Wallet Blocked
  PHONE_NUMBER_EXISTS = 10,
  PHONE_NUMBER_NOT_EXISTS = 1,
  CONTACT_DETAILS_REQUEST_LIMIT_REACHED = 8117,
  CONTACT_DETAILS_FOUND = 1
}

export enum SOCURE_VERIFICATION {
  SUCCESS = 0,
  ADDRESS_VALIDATION_FAILED = 99991,
}

export const DELIVERY_METHOD =
{
  CASH_PICKUP: {
    Id: 1,
    Key: 'CashPickup'
  },
  BANK_DEPOSIT: {
    Id: 2,
    Key: 'BankDeposit'
  },
  HOME_DELIVERY: {
    Id: 3,
    Key: 'HomeDelivery'
  },
  MOBILE_PAYMENT: {
    Id: 34,
    Key: 'MobilePayment'
  },
  RIA_WALLET: {
    Id: 140,
    Key: 'RiaWallet',
    Alias: 'MobilePayment' // Treat Ria Wallet as Mobile Wallet for BE
  },
  UPI: {
    Id: 100,
    Key: 'UPI'
  },
  ALIPAY: {
    Id: 200,
    Key: 'Alipay'
  },
  PIX: {
    Id: 300,
    Key: 'PIX'
  },
  BREB: {
    Id: 1300,
    Key: 'BreB',
    Text: 'Bre-B'
  },
  PAGO_MOVIL: {
    Id: 1000,
    Key: 'PagoMovil',
    Text: 'Pago Móvil'
  }
}

export enum INFO_PAGE {
  ERROR_LOCATION = 1,
  PHONE_VERIFIED = 2,
  NOT_DEFINED = 3,
  FORM_USER_NOT_FOUND = 4,
  COMPLETE_LINK_FAILED = 5,
  CURRENCY_EXCHANGE = 6,
  MAP_LOCATIONS = 7,
  CAMERA_DENIED_PERMISSION = 8,
  INVALID_ID = 9,
  OCR_FAILED = 10,
  OTP_ACCOUNT_BLOCKED = 11,
  NO_BENEFICIARIES = 12,
  NO_TRANSACTIONS_TRACKED = 13,
  CONTACT_SENT = 14,
  GENERIC_ERROR = 15
}

export enum RESULT_INFO_PAGES {
  ACCOUNT_CREATED = 1,
  ERROR_NOT_DEFINED = 2,
  NO_CONTACT_DATA = 3,
  INVALID_ID = 4,
  CAMERA_DENIED_PERMISSION = 5,
  OTP_ACCOUNT_BLOCKED = 6,
  OCR_FAILED = 7,
  ERROR_LOCATION = 8,
  PHONE_VERIFIED = 9,
  FORM_USER_NOT_FOUND = 10,
  NOT_DEFINED = 11
}

export enum LINK_CUSTOMER_RET_VAL {
  SUCCESS = 1,
  SMS_SENT = 10,
  NO_CONTACT_DATA = 20,
  CUSTOMER_NOT_FOUND = 30,
  CUSTOMER_WRONG = 40,
  INVALID_ID = 70,
  EXPIRED_ID = 80,
  NOT_MATCHED_ID = 90
}

export enum SET_PASSWORD_RETVAL {
  SUCCESS = 0
}

export const EVENTS_NAME = {
  HIDE_MENU: 'hideMenu',
  SHOW_DOT: 'showDot',
  SHOW_MENU: 'showMenu',
  UPDATE_PAGE: 'updateapp',
  SESSION_SAVED: 'sessionSaved',
  REFRESH_TOKEN: 'refreshToken',
  LOGOUT: 'logout',
  SHOW_ALERT: 'showAlert',
  SHOW_TOAST: 'showToast',
  APP_OFFLINE: 'appOffline',
  HIDE_FOOTER: 'hideFooter',
  HIDE_NAV_MENU: 'hideNavMenu',
  WALLET_BALANCE_REFRESH: 'walletBalanceRefresh',
  ACCERTIFY_ID_UPDATED: 'accertifyIdUpdated',
  FEATURE_FLAGS_UPDATED: 'featureFlagsUpdated'
}

export const TIME_TYPE = {
  DAY: 86400,
  HOUR: 3600,
  MINUTE: 60
}

export const MCC_CODE = {
  '202': '30',
  '204': '31',
  '206': '32',
  '208': '33',
  '212': '377',
  '213': '376',
  '214': '34',
  '216': '36',
  '218': '387',
  '219': '385',
  '220': '381',
  '222': '39',
  '226': '40',
  '228': '41',
  '230': '420',
  '231': '421',
  '232': '43',
  '234': '44',
  '238': '45',
  '240': '46',
  '242': '47',
  '244': '358',
  '246': '370',
  '247': '371',
  '248': '372',
  '250': '79',
  '255': '380',
  '257': '375',
  '259': '373',
  '260': '48',
  '262': '49',
  '266': '350',
  '268': '351',
  '270': '352',
  '272': '353',
  '274': '354',
  '276': '355',
  '278': '356',
  '280': '357',
  '282': '995',
  '283': '374',
  '284': '359',
  '286': '90',
  '288': '298',
  '289': '7',
  '290': '299',
  '292': '378',
  '293': '386',
  '294': '389',
  '295': '423',
  '297': '382',
  '302': '1',
  '308': '508',
  '310': '1671',
  '311': '1671',
  '312': '1',
  '316': '1',
  '334': '52',
  '338': '1876',
  '340': '594',
  '342': '1246',
  '344': '1268',
  '346': '1345',
  '348': '284',
  '350': '1441',
  '352': '1473',
  '354': '1664',
  '356': '1869',
  '358': '1758',
  '360': '1784',
  '362': '599',
  '363': '297',
  '364': '1242',
  '365': '1264',
  '366': '1767',
  '368': '53',
  '370': '1809',
  '372': '509',
  '374': '1868',
  '376': '1340',
  '400': '994',
  '401': '7',
  '402': '975',
  '404': '91',
  '405': '91',
  '410': '92',
  '412': '93',
  '413': '94',
  '414': '95',
  '415': '961',
  '416': '962',
  '417': '963',
  '418': '964',
  '419': '965',
  '420': '966',
  '421': '967',
  '422': '968',
  '424': '971',
  '425': '972',
  '426': '973',
  '427': '974',
  '428': '976',
  '429': '977',
  '430': '971',
  '431': '971',
  '432': '98',
  '434': '998',
  '436': '992',
  '437': '996',
  '438': '993',
  '440': '81',
  '441': '81',
  '450': '82',
  '452': '84',
  '454': '852',
  '455': '853',
  '456': '855',
  '457': '856',
  '460': '86',
  '466': '886',
  '467': '850',
  '470': '880',
  '472': '960',
  '502': '60',
  '505': '61',
  '510': '62',
  '514': '670',
  '515': '63',
  '520': '66',
  '525': '65',
  '528': '673',
  '530': '64',
  '537': '675',
  '539': '676',
  '540': '677',
  '541': '678',
  '542': '679',
  '544': '684',
  '545': '686',
  '546': '687',
  '547': '689',
  '548': '682',
  '549': '685',
  '550': '691',
  '552': '680',
  '555': '683',
  '602': '20',
  '603': '213',
  '604': '212',
  '605': '216',
  '606': '218',
  '607': '220',
  '608': '221',
  '609': '222',
  '610': '223',
  '611': '224',
  '612': '225',
  '613': '226',
  '614': '227',
  '615': '228',
  '616': '229',
  '617': '230',
  '618': '231',
  '619': '232',
  '620': '233',
  '621': '234',
  '622': '235',
  '623': '236',
  '624': '237',
  '625': '238',
  '626': '239',
  '627': '240',
  '628': '241',
  '629': '242',
  '630': '243',
  '631': '244',
  '632': '245',
  '633': '248',
  '634': '249',
  '635': '250',
  '636': '251',
  '637': '252',
  '638': '253',
  '639': '254',
  '640': '255',
  '641': '256',
  '642': '257',
  '643': '258',
  '645': '260',
  '646': '261',
  '647': '262',
  '648': '263',
  '649': '264',
  '650': '265',
  '651': '266',
  '652': '267',
  '653': '268',
  '654': '269',
  '655': '27',
  '657': '291',
  '702': '501',
  '704': '502',
  '706': '503',
  '708': '504',
  '710': '505',
  '712': '506',
  '714': '507',
  '716': '51',
  '722': '54',
  '724': '55',
  '730': '56',
  '732': '57',
  '734': '58',
  '736': '591',
  '738': '592',
  '740': '593',
  '744': '595',
  '746': '597',
  '748': '598',
  '750': '500',
  '901': '882'
};

export const MITEK_CAPTURE = {
  BACK_IMAGE: 'back_image',
  FRONT_IMAGE: 'front_image',
  FACE_IMAGE: 'face_image',
  PASSPORT_IMAGE: 'passport_image'
}

export const LOAD_FORM_ORC_RETVAL = {
  OK: 1
}

export const FORM_ORC_RETVAL = {
  OK: 1,
  NO_CONTACT_DATA: 20,
  INVALID_FIELDS: 50
}

export const FORM_VALIDATION_NAMES = {
  REQUIRED: 'required',
  REGEX: 'regex',
  MIN_LENGTH: 'minlength',
  MAX_LENGTH: 'maxlength',
  MIN_VALUE: 'minvalue',
  MAX_VALUE: 'maxvalue',
  CUSTOM: 'custom',
}

export enum OCR_FORM_RETVAL {
  OK = 1,
  KO = 10,
  EXPIRED_ID = 20,
  OCR_TIMEOUT = 40
}

export enum OCR_CHECK_STATUS {
  OK = 1,
  VERIFYING = 10
}

export enum OPTION_SELECT_IMAGE_TYPE {
  COUNTRY = 9
}

export const CUSTOMER_STATUS = {
  ON_HOLD: true,
  NOT_ON_HOLD: false
}

export enum TEXT_AREA_STATE {
  ERROR = "error",
  FOCUSED = "focused",
  DEFAULT = "default",
  WARNING = "warning",
  SUCCESS = "success",
  DISABLED = "disabled",
}

export const OCR_IMAGES_FIELD_ID = 102;
export const IMAGE_IS_NOT_LANDSCAPE  = 1616;
export const OCR_APPLICANT_ID = 444;
export const OCR_CHECK_ID = 0;

export enum CUSTOMER_ON_HOLD_STATUS {
  NOT_ON_HOLD = 1,
  ON_HOLD_CAN_SEND = 10,
  ON_HOLD_CANNOT_SEND = 20,
}

export const ORDER_ONLY_VALIDATE = {
  TRUE: true,
  FALSE: false
}

export const VERACITY_DISCLOSURE = {
  TRUE: true,
  FALSE: false
}

export const STORAGE_KEYS = {
  USER_INFO: 'user_info',
  SESSION: 'session',
  LANGUAGE_APP: 'language_app',
  FIRST_TIME: 'first_time',
  PENDING_TRANSACTION_DOT: 'pending_transaction_dot',
  REMEMBER_PREFIX: 'prefix_remebered',
  BENEFICIARIES_HOME_DELIVERY_MODAL_NOT_SHOW_AGAIN: 'beneficiaries_home_delivery_modal_not_show_again',
  BENEFICIARIES_BANK_DEPOSIT_MODAL_NOT_SHOW_AGAIN: 'beneficiaries_bank_deposit_modal_not_show_again',
  MARKETING_CONSENT_VALUE: 'marketing_consent',
  REFERRAL_CODE: 'referral_code',
};

  export const OTP_RESULT = {
    SUCCESS: 1,
    VALID: 10,
    ERROR_UPDATING: 30,
    INVALID: 70,
    BLOCKED: 80,
    INTERNAL_BETWEEN_ATTEMPTS: 100,
    SEND_MFA_MAX_ATTEMPTS: {
      REGISTRATION: 110,
      GENERAL: 120,
      FORGOT_MAX_ATTEMPTS: 140,
      FORGOT: 150,
      SIGNIN: 210
    },
    BLOCKEDACCOUNT: 90,
    ACCOUNT_EXISTS_ALREADY: 300,
    COOLDOWN_STATUS: 250,
    OTP_SEND_BLOCKED: 320,
    TWILIO_SERVICE_UNAVAILABLE_STATUS: 1540
  }

  export const OTP_SESSION_EXPIRED_KEY_MAP = {
    'otpnotfoundonresend': 'otp.sessionExpired.resend',
    'otpnotfoundphoneverification': 'otp.sessionExpired.phoneVerification',
    'otpnotfoundregistration': 'otp.sessionExpired.registration',
    'otpnotfoundpwdrecovery': 'otp.sessionExpired.pwdRecovery',
    'otpnotfounddevicetokenization': 'otp.sessionExpired.deviceTokenization',
  };

  export const OTP_ACTIONS = {
    LOGIN: 20,
    CHANGE_PASSWORD: 30,
    RECOVERY_PASSWORD: 40,
    NEW_ORDER: 50,
    REGISTRATION: 60,
    VERIFYPHONE: 70,
    LOGINTOKEN: 80,
    VERIFYPHONE2: 90,
    PASS_SECURITY_QUESTIONS: 100,
    WALLET_RESET_PIN: 110,
    WALLET_FORGOT_PIN: 120,
    FRAUD_CHECK_CONFIRMATION: 170,
  }

  export const OTP_HEADER_RET_VAL = {
    NO_CONTACT_DATA: 20,
    ACCOUNT_BLOCKED: 2010
  }

  export const IP_VALIDATION_REASON_CODE = {
    LOGIN_IP_RESTRICTED: 6,
    REGISTRATION_IP_RESTRICTED: 10,
    REGISTRATION_LOCAL_IP_REQUIRED: 11,
    REGISTRATION_COUNTRY_NOT_ALLOWED: 12
  }

  export const COUNTRY_DECLARATION_REASON_CODE = {
    COUNTRY_NOT_IDENTIFIED: '13',
    SELECTION_ID_INVALID_OR_EXPIRED: '14'
  }

  export const COUNTRY_DECLARATION_HEADER = {
    SELECTION_ID: 'X-Country-Selection-Id',
    DECLARED_COUNTRY_CODE: 'X-Declared-Country-Code'
  }

  export const FORGOT_PASSWORD_OTP_RET_VAL = {
    OTP_REQUIRED: 4200,
    OTP_CREATE_FAILED: 110,
    OTP_NO_CONTACT_DATA: 60
  }


  export const OTP_REGISTRATION_RET_VAL = {
    OK: 1,
    INTERVAL_ATTEMPTS: 62,
    BLOCKED_BY_OTP_FAILED_ATTEMPS: 110,
    BLOCKED_BY_TWILIO: 120
  }

  export const FORGOT_PASSWORD_RET_VAL = {
    SUCCESS: 1,
    CUSTOMER_NOT_FOUND: 20,
    NOT_CUSTOMER_FOUND: 50,
    INTERVAL_BETWEEN_ATTEMPTS: 130,
    INVALID_BIRTHDATE: 250,
    INVALID_REFERENCE_VALUE: 260,
    INVALID_CUSTOMER: 270
  }

  // VerifyBirthdateForLogin, plus the 330 email-OTP validation returns until the date is verified
  export const LOGIN_BIRTH_DATE_RET_VAL = {
    SUCCESS: 1,
    INVALID_TOKEN: 30,
    INTERVAL_BETWEEN_ATTEMPTS: 200,
    BIRTH_DATE_REQUIRED: 330,
    INVALID_BIRTH_DATE: 360
  }

  export const RESEND_ACTIONS = {
    LOGIN: 1,
    NEW_ORDER: 2,
    CHANGE_PASSWORD: 3,
    RESET_PASSWORD: 4
  }

  export enum FLOW_STEPS {
    WELCOME = 'welcome',
    DOCUMENT = 'document',
    FACE = 'face',
    FACE_VIDEO = 'face_video',
    FINAL = 'final',
  }

  export const CARD_TYPE = {
    VISA: {
      Id: 1,
      Key: "Visa"
    },
    MASTERCARD: {
      Id: 2,
      Key: "MasterCard"
    },
    MAESTRO: {
      Id: 3,
      Key: "Maestro"
    },
    DISCOVER: {
      Id: 4,
      Key: "Discover"
    }
  }

  export const CARD_BIN_TYPE = {
    ITALY_POSTEPAY: 'ItalyPostePayPosteItaliane',
    PORTUGAL_NOVOBANCO: 'PortugalNovobanco'
  }

  export const PROMOTION_TYPE = {
    GENERICNEWCUSTOMERS: 10,
    GENERICALLCUSTOMERS: 20,
    GENERICUNLIMITED: 30,
    UNIQUE: 40,
    WINBACK: 50,
    LOYALTY: 60,
    LOYALTYCARD: 70,
    CUSTOMERREFERRAL: 80,
    INCREMENTALPROMOCODES: 90
  }

  export const CUSTOMER_LINKING_FIELDS  = {
    DATE_OF_BIRTH: 5,
    ID_NUMBER: 4,
    ID_EXPIRATION: 8,
    NATIONALITY: 9
  }

  export const LOQATE_TYPES = {
    ADDRESS: 'Address',
    STREET: 'Street'
  }

  export const DIGITAL_LICENSE = {
    LITUANIA: 'LT'
  }

  export const LOQATE_RESPONSE_STATUS = {
    SUCCESS: 10,
    FAILURE: 20,
    MANUAL_ADDRESS_ENABLED: 30,
    MANUAL_ADDRESS_DISABLED: 40
  }

  export const MOBILE_WALLET_VALIDATION = {
    SUCCESS: 10,
    ERROR: 20,
    INVALID_ACCOUNT: 30,
    INVALID_BENEFICIARY: 40,
    ACCOUNT_NO_KYC: 50,
    LIMIT_TRANSACTION_AMOUNT: 60,
    LIMIT_YEAR_COUNT: 70,
    LIMIT_YEAR_AMOUNT: 80,
    LIMIT_ERROR_BALANCE: 90,
    CURRENCY_MISMATCH: 100,
    ACCOUNT_NO_REMITTANCE: 110,
    ACCOUNT_NOT_EXIST: 120,
    LITE_WALLET_NO_KYC: 130
  }

  export const BANK_ACCOUNT_VALIDATION = {
    ACCOUNT_INFO_INCORRECT: 8000,
    BANK_API_UNAVAILABLE: 1000
  }

  // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!! OBSOLETE => REPLACE WITH EKYC_PROCESSOR_TYPE
  export const EKYC_PROCESSOR = {
    0: 'None',
    2000: 'ExperianPID',
    2001: 'ExperianKIQ',
    2004: 'CustomerServiceMatchedExistingCustomer',
    2002: 'IDOlogyExpectIQID',
    2006: 'JumioKYC',
    2003: 'IDOlogyPreciseID',
    10005: 'Klarna',
    2020: 'Equifax',
    1000: 'MatchedByCS',
    2005: 'MatchedByOnline',
    2030: 'ID3Global',
    10006: 'SiftScience',
    2040: 'TruNarrative',
    2070: 'Onfido',
    2075: 'Singpass',
    2080: 'Veriff',
    2090: 'Signicat',
    2095: 'Socure',
    2100: 'DigitalIDVerification',
    9600: 'FPX'
    
  }

  export enum EKYC_PROCESSOR_TYPE {
    None = 0,
    ExperianPID = 2000,
    ExperianKIQ = 2001,
    IDOlogyExpectIQID = 2002,
    CustomerServiceMatchedExistingCustomer = 2004,
    JumioKYC = 2006,
    IDOlogyPreciseID = 2003,
    Klarna = 10005,
    Equifax = 2020,
    MatchedByCS = 1000,
    MatchedByOnline = 2005,
    ID3Global= 2030,
    SiftScience = 10006,
    TruNarrative = 2040,
    Onfido = 2070,
    Singpass = 2075,
    Veriff = 2080,
    Signicat = 2090,
    Socure = 2095,
    DigitalIDVerification = 2100,
    FPX = 9600
  }

  export const WALLET_FIELDS = {
    REASONS: 10,
    RELATIONSHIP: 20
  }

  export const WALLET_ACTIVATION_RETVAL = {
    SUCCESS: 1,
    ACCOUNT_EXISTS: 5400,
    INVALID_DATA_LENGTH: 5900,
    NO_RECORD_FOUND: 65,
    GENERIC_ERROR: 998,
    PROVIDER_COMMUNICATION_ERROR: 999,
    UNKOWN_ERROR: 1000
  }

export const PHONE_VERIFICATION_EVENT_LOCATION = {
  REGISTRATION: 'Registration',
  CHANGE_RESOURCE: 'ChangeResource',
  LOGIN: 'Login',
  PASSWORD_RECOVERY: 'PasswordRecovery'
}

export const REGISTRATION_RESOURCE_TYPE = {
  EMAIL: 10,
  PHONE: 20
}

export const LITE_REGISTRATION_FIELDS = {
  EMAIL: {Name: 'EmailAddress', Id: '18001'},
  CELL_NUMBER: {Name: 'CustCellNo', Id: '17501'},
  STREET_ADDRESS: {Name: 'StreetAddress', Id: '4501'},
  CITY: {Name: 'City', Id: '4601'},
  STATE: {Name: 'State', Id: '4701'},
  POSTAL_CODE: {Name: 'PostalCode', Id: '4801'},
  COUNTRY: {Name: 'Country', Id: '4901'},
  CUSTOMER_FIRST_NAME: {Name: 'FirstName', Id: '8601'},
  CUSTOMER_LAST_NAME: {Name: 'LastName', Id: '8701'},
  DATE_OF_BIRTH: {Name: 'BirthDate', Id: '15201'},
  OCCUPATION: {Name: 'Occupation', Id: '15301'},
  APARTMENT_OR_UNIT: {Name: 'ApartmentORUnitNumber', Id: '46403'},
}

export const ACCOUNT_DELETION = {
  OK: 1,
  ALREADY_REQUESTED: 10,
  DELETED: 20,
  DISABLED: 30,
  PENDING: 40,
  ERROR: 99
}

export const REGISTRATION_FIELDS_ID = {
  DRIVER_LICENSE_FIELD_ID: '14601',
  DRIVER_LICENSE_FIELD_VALUE: '10112',
  PASSPORT_FIELD_VALUE: '10212',
  ISSUED_COUNTRY_FIELD_ID: '19001',
  ID_NUMBER: '14801',
  CARD_NUMBER: '99999',
  ISSUED_BY_COUNTRY: '19001',
  ISSUED_BY_STATE: '19101',
  BUSINESS_SECTOR_ID: '39005'
}

export const ADDITIONAL_DETAILS_FIELDS_ID = {
  ID_DOCUMENT_TYPE: 'idDocumentTypeId',
  ID_DOCUMENT_NUMBER: 'idDocumentNumber',
  STAGED_TRX_ID_DOCUMENT_TYPE: '14601', 
  STAGED_TRX_ID_DOCUMENT_NUMBER: '14801',
  CL_NATIONAL_ID_RUT: '11512',  // For Staged Trx
  MERCOSUR_NATIONAL_ALIEN_CARD: '17314', // For Staged Trx
  NON_MERCOSUR_NATIONAL_ID: '601', // For Digital Trx
  MERCOSUR_NATIONAL_RP: '1301',   // For Digital Trx
  CNPJ: '11112',
  CPF: '14311',
  STAGED_TRX_BEN_DOB: '44902', // For Staged Trx
  BEN_DOB: 'dOB', // For Digital Trx
}

export enum AUSTRALIAN_STATE_CODES {
  AUSTRALIAN_CAPITAL_TERRITORY = "269611",
  NEW_SOUTH_WALES = "269011",
  NORTHERN_TERRITORY = "269511",
  QUEENSLAND = "269111",
  SOUTH_AUSTRALIA = "269311",
  TASMANIA = "269711",
  VICTORIA = "269211",
  WESTERN_AUSTRALIA = "269411"
}

export const LANGUAGES = {
  'en-US': { text: 'English (US)', visibleValue: 'EN', value: 'en-US', Name: 'English (United States)' },
  'en-GB': { text: 'English (UK)', visibleValue: 'EN', value: 'en-GB', Name: 'English (United Kingdom)' },
  'es-US': { text: 'Español (America)', visibleValue: 'ES', value: 'es-US', Name: 'Spanish (United States)' },
  'es-ES': { text: 'Español', visibleValue: 'ES', value: 'es-ES', Name: 'Spanish (Spain)' },
  'fr-CA': { text: 'Français Canadien', visibleValue: 'FR', value: 'fr-CA', Name: 'French (Canada)' },
  'fr-FR': { text: 'Français', visibleValue: 'FR', value: 'fr-FR', Name: 'French (France)' },
  'nl-NL': { text: 'Nederlands', visibleValue: 'NL', value: 'nl-NL', Name: 'Dutch (Netherlands)' },
  'id-ID': { text: 'Bahasa Indonesia', visibleValue: 'ID', value: 'id-ID', Name: 'Indonesian (Indonesia)' },
  'bn-BD': { text: 'বাংলা', visibleValue: 'BD', value: 'bn-BD', Name: 'Bengali (Bangladesh)' },
  'da-DK': { text: 'Dansk', visibleValue: 'DK', value: 'da-DK', Name: 'Danish (Denmark)' },
  'fi-FI': { text: 'Suomen kieli', visibleValue: 'FI', value: 'fi-FI', Name: 'Finnish (Finland)' },
  'de-DE': { text: 'Deutsch', visibleValue: 'DE', value: 'de-DE', Name: 'German (Germany)' },
  'it-IT': { text: 'Italiano', visibleValue: 'IT', value: 'it-IT', Name: 'Italian (Italy)' },
  'lt-LT': { text: 'Lietuvių', visibleValue: 'LT', value: 'lt-LT', Name: 'Lithuanian (Lithuania)' },
  'ms-MY': { text: 'Bahasa Melayu', visibleValue: 'MY', value: 'ms-MY', Name: 'Malay (Malaysia)' },
  'ne-NP': { text: 'नेपाली', visibleValue: 'NP', value: 'ne-NP', Name: 'Nepali (Nepal)' },
  'nb-NO': { text: 'Norsk bokmål', visibleValue: 'NO', value: 'nb-NO', Name: 'Norwegian Bokmål (Norway)' },
  'pl-PL': { text: 'Polski', visibleValue: 'PL', value: 'pl-PL', Name: 'Polish (Poland)' },
  'pt-PT': { text: 'Português', visibleValue: 'PT', value: 'pt-PT', Name: 'Portuguese (Portugal)' },
  'sv-SE': { text: 'Svenska', visibleValue: 'SV', value: 'sv-SE', Name: 'Swedish (Sweden)' },
  'tl-PH': { text: 'Tagalog', visibleValue: 'TL', value: 'tl-PH', Name: 'Tagalog (Philippines)' },
  'th-TH': { text: 'ไทย', visibleValue: 'TH', value: 'th-TH', Name: 'Thai (Thailand)' },
  'vi-VN': { text: 'Tiếng Việt', visibleValue: 'VI', value: 'vi-VN', Name: 'Vietnamese (Vietnam)' },
  'ru-RU': { text: 'Русский', visibleValue: 'RU', value: 'ru-RU', Name: 'Russian (Russia)' },
  'uk-UA': { text: 'українська', visibleValue: 'UA', value: 'uk-UA', Name: 'Ukrainian (Ukraine)' },
  'zh-CN': { text: '中文', visibleValue: 'CN', value: 'zh-CN', Name: 'Chinese (China)' },
  'cs-CZ': { text: 'Čeština', visibleValue: 'CZ', value: 'cs-CZ', Name: 'Czech (Czech Republic)' },
  'ro-RO': { text: 'Română', visibleValue: 'RO', value: 'ro-RO', Name: 'Romanian (Romania)' },
  'el-GR': { text: 'Ελληνικά', visibleValue: 'GR', value: 'el-GR', Name: 'Greek (Greece)' },
}

export const EVENTS_VALUES = {
 RAF: 'RAF',
 PHONE_NUMBER: 'Phone Number',
 EMAIL: 'Email',
 SMS: 'SMS',
 VOICE: 'Voice',
 WHATSAPP: 'WhatsApp',
 CALL: 'Call',
 CALL_ME_INSTEAD: 'Call Me Instead',
 RESEND_CODE: 'Resend Code',
 TRY_PHONE: 'Try Phone',
 TRY_EMAIL: 'Try Email',
}

export const DELETE_ACCOUNT_VALUE = {
  CANT_MAKE_TRANSFER: 'I couldn\'t make a transfer', 
  TRANSFER_TOO_LONG: 'Transfers taking too long',
  SEND_MORE_MONEY: 'I want to send more money',
  BETTER_RATE: 'I get a better rate somewhere else',
  NOT_USING_ACCOUNT: 'I\'m not using my account anymore',
  OTHER_REASON: 'Other reason'
}

export enum AllowedDocuments {
  NATIONAL_IDENTITY_CARD = "NATIONAL_IDENTITY_CARD",
  RESIDENCE_PERMIT = "RESIDENCE_PERMIT",
  DRIVING_LICENCE = "DRIVING_LICENCE",
  PASSPORT = "PASSPORT"
}

export enum DOCUMENT_ID_TYPES {
  DRIVER_LICENSE = 'G301',
  PASSPORT = 'G401'
}

export const TRANSACTION_REASON_OPTIONS_P2P = 47109;
export const TRANSACTION_REASON_OPTIONS_WALLET_TO_BANK = 47108;

export enum AddressType {
  ANY = 0,
  BUSINESS = 10,
  BILLING = 12,
  HOME = 20,
  MAILING = 30
}

export enum WalletBalanceSN {
  FULL_WALLET_BAL_LIMIT = 49008,
  FULL_WALLET_INFLOW_LIMIT = 49009,
  LITE_WALLET_BAL_LIMIT = 49010,
  LITE_WALLET_INFLOW_LIMIT = 49011,
}

export enum EMAIL_REQUEST_TYPE {
  SANDBOX_VISA_UPLOAD = 410
}

export enum AppleOrGoogleWalletType {
  Debit = "debit",
  Credit = "credit"
}

export enum AppleOrGoogleWalletCapability{
  Debit = "debit",
  Credit = "credit",
  ThreeDS = '3ds'
}

export enum PromiseStatus{
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected'
}

export enum TopupError {
  EXCEPTION_DURING_TOPUP = ' Unknown Exception during topup',
  FAILED_TO_GET_PROVIDER = 'Failed to get provider',
}

export enum P2PError {
  FAILED_TO_PROCESS_SEND_OR_REQUEST = 'Failed to process send or request',
  FAILED_TO_PROCESS_TRANSACTION = 'Failed to process transaction',
  FAILED_TO_PROCESS_WITHDRAWAL_OR_PAYMENT = 'Failed to process withdrawal or payment'
}

// Temp min limit till Eduardo confirms the final min value
export enum DUITNOW_LIMIT {
  MIN_AMOUNT = 1
}

export const DEFAULT_AMOUNTS = {
  CL: 100000,
  DEFAULT: 100,
}

export enum CountryDeeplinkEventType {
  NEWFLOW = 1
}

@Injectable()
export class AppVariables {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/providers/myria/app-variables.ts